import React from 'react';
import { brand } from '../agentTheme';

/**
 * Mobile header bar with hamburger menu and generation panel toggle.
 */
export default function MobileHeader({ brandName, threadTitle, onOpenSidebar, onOpenGenerations, completedCount = 0 }) {
  return (
    <div style={{
      height: 52, padding: '0 14px', display: 'flex', alignItems: 'center', gap: 10,
      background: 'rgba(12,12,18,0.95)', backdropFilter: 'blur(16px)',
      borderBottom: '1px solid rgba(255,255,255,0.06)',
      position: 'sticky', top: 0, zIndex: 10, flexShrink: 0,
    }}>
      {/* Hamburger */}
      <button
        onClick={onOpenSidebar}
        aria-label="Open sidebar"
        style={{
          width: 32, height: 32, borderRadius: 8, background: 'rgba(255,255,255,0.04)',
          border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: 'rgba(255,255,255,0.6)', flexShrink: 0,
        }}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="18" x2="21" y2="18" />
        </svg>
      </button>

      {/* Brand + Thread */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{
          fontSize: 14, fontWeight: 600, color: '#FFFFFF',
          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
        }}>
          {brandName || 'AI Agent'}
        </div>
        {threadTitle && (
          <div style={{
            fontSize: 11, color: 'rgba(255,255,255,0.3)',
            overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
          }}>
            {threadTitle}
          </div>
        )}
      </div>

      {/* Generations toggle */}
      <button
        onClick={onOpenGenerations}
        aria-label="Show generations"
        style={{
          width: 32, height: 32, borderRadius: 8, background: 'rgba(255,255,255,0.04)',
          border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: 'rgba(255,255,255,0.6)', flexShrink: 0, position: 'relative',
        }}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /><rect x="14" y="14" width="7" height="7" />
        </svg>
        {completedCount > 0 && (
          <span style={{
            position: 'absolute', top: -2, right: -2,
            width: 16, height: 16, borderRadius: '50%',
            background: brand.coral, color: '#fff',
            fontSize: 9, fontWeight: 700,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            {completedCount > 9 ? '9+' : completedCount}
          </span>
        )}
      </button>
    </div>
  );
}
